import type { ConversationSummary } from '@/services/message.service';
import { threadToTranscript, type TicketThread } from '@/services/ticket.service';
import type { TranscriptMessage } from './conversation-parts';

/** A real thread loaded into the simulator: a conversation from the inbox or a helpdesk ticket. */
export interface LoadedThread {
	kind: 'conversation' | 'ticket';
	id: string;
	/** What the run is keyed on; null when no conversation carries the ticket. */
	conversationId: number | null;
	contact: { name: string | null; email: string | null } | null;
	subject: string | null;
	channel: string | null;
	messages: TranscriptMessage[];
}

export const threadFromConversation = (conversation: ConversationSummary, messages: TranscriptMessage[]): LoadedThread => ({
	kind: 'conversation',
	id: String(conversation.conversationId),
	conversationId: conversation.conversationId,
	contact: conversation.contact
		? { name: conversation.contact.name ?? null, email: conversation.contact.email ?? null }
		: null,
	subject: conversation.subject,
	channel: conversation.channel,
	messages
});

export const threadFromTicket = (thread: TicketThread): LoadedThread => ({
	kind: 'ticket',
	id: thread.externalTicketId,
	conversationId: thread.conversationId,
	contact: thread.customer,
	subject: null,
	channel: null,
	messages: threadToTranscript(thread)
});
